export const ClientType = {
  DA: "Desktop Application",
  DW: "Desktop Web",
  MW: "Mobile Web",
  MA: "Mobile Application",
  MS: "Mobile Text/SMS",
  UW: "Unknown Web",
  UA: "Unknown Application"
};
